import { Box, IconButton, Modal, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useRef } from "react";
import Getcurrentlocation from "../common/Getcurrentlocation";
import "./Selectoption.css";
import {
  setProjectimages,
  setSelectedsite,
  setSelectlocation,
  setShowaddproject,
  setShowmapmodal
} from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";

const Selectoption = (props) => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [options, setOptions] = useState([]);
  const { multiLanguageData, showMapmodal } = useSelector((state) => state?.main);

  const {
    TEXT_SELECT_OPTION = English?.SelectOption?.TEXT_SELECT_OPTION,
    FAB_TEXT_ADD_SITE = English?.SelectOption?.FAB_TEXT_ADD_SITE,
    FAB_TEXT_PIN_MY_LOCATION = English?.SelectOption?.FAB_TEXT_PIN_MY_LOCATION,
    FAB_TEXT_ADD_PROJECT = English?.SelectOption?.FAB_TEXT_ADD_PROJECT || "Add Project",
    TEST_SELECT_IMAGE = English?.SelectOption?.TEST_SELECT_IMAGE
  } = multiLanguageData?.SelectOption || {};

  let getOptions = [
    {
      id: 0,
      text: FAB_TEXT_ADD_SITE,
      icon: <AddIcon className="opt-icon" />
    },
    {
      id: 1,
      text: FAB_TEXT_PIN_MY_LOCATION,
      icon: <LocationOnIcon className="opt-icon" />
    },
    {
      id: 2,
      text: FAB_TEXT_ADD_PROJECT,
      icon: <AddIcon className="opt-icon" />
    }
  ];

  useEffect(() => {
    if (props.showOption) {
      if (props.showNavigation) {
        setOptions(getOptions);
      } else {
        let getList;
        getList = getOptions.filter((item) => item.id !== 0);
        setOptions(getList);
      }
    }
  }, [props.showOption]);

  const handleClose = () => {
    props?.setShowoption(false);
  };

  const addSite = async (item) => {
    handleClose();
    switch (item?.id) {
      case 0:
        let locationModal = {
          open: false,
          lat: 0,
          lng: 0
        };
        dispatch(setSelectlocation(locationModal));
        props.setShowaddsite(true);
        break;
      case 1:
        let getCurrentLocation = {
          open: false,
          lat: props?.currentLocation?.lat,
          lng: props?.currentLocation?.lng
        };
        dispatch(setSelectlocation(getCurrentLocation));
        props.showNavigation ? props.setShowaddsite(true) : dispatch(setShowaddproject(true));

        if (showMapmodal?.select !== "add-site") {
          let mapModal = {
            open: false,
            from: showMapmodal?.from,
            select: "project"
          };
          dispatch(setShowmapmodal(mapModal));
        }

        let selectedSite = {
          // If site detail have dropped pinned
          id: 0,
          name: "",
          latitude: props?.currentLocation?.lat,
          longitude: props?.currentLocation?.lng
        };
        dispatch(setSelectedsite(selectedSite));
        break;
      case 2:
        // Add Project from Map
        if (props.setShowAddProjectFromMap) {
          let closeMapModal = {
            lat: 0,
            lng: 0,
            open: false,
            from: ""
          };
          dispatch(setSelectlocation(closeMapModal));
          props.setShowAddProjectFromMap(true);
        }
        break;
      default:
        break;
    }
  };

  function handleChooseFile(event) {
    handleClose();
    const files = event.target.files;
    let allFilesValid = true;
    if (files?.length > 0) {
      for (let i = 0; i < files.length; i++) {
        if (!files[i].type.startsWith("image/")) {
          allFilesValid = false;
          break;
        }
      }
    }
    if (!allFilesValid) {
      return alert("Please select valid image files (JPEG, PNG, GIF, etc.).");
    }
    let images = [];
    for (let i = 0; i < files?.length; i++) {
      images.push(files[i]);
    }
    let mapModal = {
      open: false,
      from: showMapmodal?.from,
      select: "project"
    };
    dispatch(setShowmapmodal(mapModal));

    dispatch(setProjectimages(images ?? []));
    dispatch(setShowaddproject(true));
    event.target.value = null;
  }

  return (
    <>
      <Modal open={props.showOption} onClose={handleClose}>
        <Box
          className="user-modal-responsive select-option"
          style={{ maxWidth: props.from === "modal" ? "300px" : "420px" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "20px"
            }}>
            <Typography className="add-title" style={{ margin: "0px" }}>
              {TEXT_SELECT_OPTION}
            </Typography>
            <CloseIcon style={{ color: "#083DB8", cursor: "pointer" }} onClick={handleClose} />
          </Box>
          <Stack sx={{ alignItems: "flex-start", justifyContent: "space-between" }} direction={"row"}>
            {options.map((item) => (
              <Stack
                key={item.text}
                className="select-loc"
                sx={{ alignItems: "center" }}
                gap={1}
                onClick={() => addSite(item)}>
                <IconButton className="modal-icon">{item?.icon}</IconButton>
                <span className="modal-text" style={{ border: "none" }}>
                  {item?.text}
                </span>
              </Stack>
            ))}
            {showMapmodal?.select !== "add-site" && (
              <Stack
                className="select-loc"
                sx={{ alignItems: "center" }}
                gap={1}
                onClick={() => {
                  fileInputRef.current.click();
                }}>
                <input
                  ref={fileInputRef}
                  id="timeSheetPicture-upload"
                  type="file"
                  multiple
                  accept="image/*"
                  onChange={(e) => handleChooseFile(e)}
                  hidden
                />

                <IconButton className="modal-icon">
                  <InsertPhotoIcon className="opt-icon" />
                </IconButton>
                <span className="modal-text" style={{ border: "none" }}>
                  {TEST_SELECT_IMAGE}
                </span>
              </Stack>
            )}
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default Selectoption;
